import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next';
import { PageNames, PageContext } from '../Home/HomeTopMailConfirm';
import { Box, Button, Container, TextField } from '@mui/material';
import { Title } from '../Component/Title';
import { Info } from "../Component/Info"
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { useForm } from 'react-hook-form';
import { ErrorIndicator } from '../Utility/ErrorIndicator';
import { HeldTimesContext } from '../Root/CompetitionRoot';

/**
 * ログインフォームの型
 */
export interface KaguRefFormInputType{
    mailAddress: string,
    artworkId: string
}

/**
 * 登録情報の型
 */
export interface KaguRefDataType {
    //登録情報
    state: number,
    artwork_id: string,
    country_id: number,
    country_name: string,
    poster: string,
    birthday: string,
    educational_institution_country_id: number,
    educational_institution_country_name: string,
    educational_institution: string,
    mailaddress: string,
    group_flg: boolean,
    group_num: number,
    artwork_file_name: string,
    proof_file_name: string,
    interest_work: boolean,
    fiscal_year: number,
    group_info: GroupDataType[]
}

/**
 * 登録情報の中のグループメンバー情報の型
 */
export interface GroupDataType {
    group_id: string,
    country_id: number,
    country_name: string,
    poster: string,
    birthday: string,
    educational_institution_country_id: number,
    educational_institution_country_name: string,
    educational_institution: string,
    proof_file_name: string,
}

/**
 * 登録内容確認のログインフォーム
 * 作品IDとメールアドレスでログインする
 */
export function KaguRefForm({setKaguRefData}:{setKaguRefData:(data:KaguRefDataType) => void}) {

    const [t] = useTranslation();

    const {setPage} = useContext(PageContext);

    const heldTimesOption = useContext(HeldTimesContext);

    const {register, handleSubmit, formState:{errors}} = useForm<KaguRefFormInputType>();

    async function onSubmit(inputData: KaguRefFormInputType) {

        setPage(PageNames.Processing)

        const GetAddress = `/competition/api/registration/kmr010?artworkId=${inputData?.artworkId}&mailaddress=${inputData?.mailAddress}`

        await fetch(GetAddress)
        .then(res => {
            return res.ok ? res.json() : undefined
        })
        .then(res => {
            setKaguRefData(res);

            if (res.state === 1) {
                setPage(PageNames.KaguRefInfo);
            } else {
                setPage(PageNames.KaguRefNotReg)
            }          
        })
        .catch(err => {
            console.error(err);
            setPage(PageNames.ProcessError);
        })
    }

    return(
        <>
            <Box>
                <Title>
                    {t("KaguRefForm.Title", heldTimesOption)}
                </Title>
                <Info>
                    {t("KaguRefForm.Text1")}
                </Info>
            </Box>

            <Container maxWidth="sm">
                <Box mt={1}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <TextField id="mailAddress" label={t("KaguRefForm.MailAddress")} variant="outlined" fullWidth
                            margin="normal"
                            sx={{
                                backgroundColor:"white"
                            }}
                            error={errors.mailAddress ? true : false}
                            helperText={ErrorIndicator(errors.mailAddress)}
                            {...register("mailAddress", {required: true, pattern: /^\S+@\S+$/i})}
                        />
                        
                        <TextField id="RegistrationID" label={t("KaguRefForm.RegistrationID")} variant="outlined" fullWidth
                            margin="normal"
                            sx={{
                                backgroundColor:"white"
                            }}
                            error={errors.artworkId ? true : false}
                            helperText={ErrorIndicator(errors.artworkId)}
                            {...register("artworkId", {required: true, maxLength: 10})}
                        />

                        <Grid2 container spacing={1} mt={1}>
                            <Grid2>
                                <Button variant="contained" type="submit">{t("KaguRefForm.Login")}</Button>
                            </Grid2>
                            <Grid2>
                                <Button variant="outlined" onClick={() => setPage(PageNames.KaguTop)}>{t("Common.Back")}</Button>
                            </Grid2>
                        </Grid2>
                    </form>
                </Box>
            </Container>   
        </>
    );
}